function initSearch() {
    const searchField = document.querySelector('#Form_SearchPracForm_Location');
    if (!searchField) {
        return;
    }

    setTimeout(() => {
        const autoComplete = new google.maps.places.Autocomplete(
            document.querySelector('#Form_SearchPracForm_Location'),
            {
                types: [
                    'postal_code',
                    'locality',
                    'administrative_area_level_3'
                ],
                componentRestrictions: {
                    country: 'au'
                }
            }
        );

        const urlParams = new URLSearchParams(window.location.search);
        const locationParam = urlParams.get('Location');
        if (locationParam) {
            searchField.value = locationParam;
        }
    }, 500);
}

window.initSearch = initSearch;
